
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import StatusBadge from '@/components/common/StatusBadge';
import { formatDate } from '@/utils/formatters';
import { PaymentRequest } from '@/types';

interface RecentPaymentRequestsProps {
  payments: PaymentRequest[];
  authors: any[];
  onViewAll: () => void;
}

const RecentPaymentRequests: React.FC<RecentPaymentRequestsProps> = ({ payments, authors, onViewAll }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Recent Payment Requests</CardTitle>
          <CardDescription>Latest payment requests from authors</CardDescription>
        </div>
        <div 
          className="cursor-pointer text-royalty-600 hover:text-royalty-800"
          onClick={onViewAll}
        >
          View All
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Author</TableHead>
              <TableHead className="text-right">Amount</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payments.map((payment) => {
              const author = authors.find(a => a.id === payment.authorId);
              return (
                <TableRow key={payment.id}>
                  <TableCell>{author?.name}</TableCell>
                  <TableCell className="text-right">${payment.amount.toFixed(2)}</TableCell>
                  <TableCell>
                    <StatusBadge status={payment.status} />
                  </TableCell>
                  <TableCell>{formatDate(payment.requestDate)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default RecentPaymentRequests;
